import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'div'>

export const PageLayout: FC<Props> = ({ className, children, ...props }) => {
  return (
    <div
      {...props}
      className={clsx(['mb-4 mr-4 flex-1 rounded-2xl bg-body p-4', className])}
    >
      {children}
    </div>
  )
}
